export const Colors = {
  darkEarth: '#3A3532',
  highlight: '#DB9A35',
  lightAccent: {
    light: '#DBCBB2',
    dark: '#D2C3AA'
  },
  white: 'rgba(255, 255, 255, 0.7)',
  pink: '#EAE0DE'
}